import {
  ArrowLeftRight,
  Banknote,
  FileCheck,
  Radar,
  ShieldCheck,
  Smartphone,
} from "lucide-react";
import { Reveal, SectionHeader } from "./Reveal";

const FEATURES = [
  {
    icon: ArrowLeftRight,
    title: "USDT to INR Exchange",
    desc: "Simple conversion from USDT to INR.",
    testid: "feature-card-1",
  },
  {
    icon: Banknote,
    title: "Cash Deposit Support",
    desc: "Convenient INR payment through supported cash deposit channels.",
    testid: "feature-card-2",
  },
  {
    icon: Radar,
    title: "Order Tracking",
    desc: "View your exchange order status from your account.",
    testid: "feature-card-3",
  },
  {
    icon: ShieldCheck,
    title: "Secure Account",
    desc: "User accounts and order information are protected.",
    testid: "feature-card-4",
  },
  {
    icon: FileCheck,
    title: "Transparent Process",
    desc: "Review order details before submitting.",
    testid: "feature-card-5",
  },
  {
    icon: Smartphone,
    title: "Mobile Friendly",
    desc: "Fully responsive experience for mobile, tablet and desktop.",
    testid: "feature-card-6",
  },
];

export default function Features() {
  return (
    <section id="features" data-testid="features-section" className="section-pad relative">
      <div className="container-x relative">
        <SectionHeader
          testid="features"
          eyebrow="Features"
          title="Why Choose CDM Pay"
          sub="A focused exchange experience built around clarity, security and simplicity."
        />

        <div className="mt-16 grid gap-6 sm:gap-8 md:grid-cols-2 lg:grid-cols-3">
          {FEATURES.map(({ icon: Icon, title, desc, testid }, i) => (
            <Reveal key={title} delay={(i % 3) * 0.1}>
              <div
                data-testid={testid}
                className="group glass-card h-full p-6 transition-all duration-300 hover:-translate-y-1.5 hover:border-emerald-400/30 hover:shadow-glow-sm sm:p-8"
              >
                <div className="mb-6 grid h-12 w-12 place-items-center rounded-xl border border-emerald-400/25 bg-emerald-400/10 transition-colors duration-300 group-hover:bg-emerald-400/20">
                  <Icon className="h-6 w-6 text-emerald-400" />
                </div>
                <h3 className="font-display text-xl font-semibold tracking-tight text-white">
                  {title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-400 sm:text-base">
                  {desc}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
